import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Avatar, Card, Empty, Table, Tag } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { listUsers } from '../api';
import { PageHeader } from '../components/PageHeader';
import { initial } from './dashboard/helpers';
export default function UsersScreen() {
    const nav = useNavigate();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                setRows(await listUsers());
            }
            catch { /* client auto-surfaces */ }
            finally {
                setLoading(false);
            }
        })();
    }, []);
    const cols = [
        {
            title: '', key: '__avatar', width: 48, align: 'center',
            render: (_, r) => {
                const name = (r.display_name && r.display_name.trim()) || r.email;
                return (_jsx(Avatar, { size: 28, src: r.avatar_url || undefined, style: { background: '#EFE9FA', color: '#6B21A8', fontWeight: 600, fontSize: 12 }, children: initial(name) }));
            },
        },
        { title: '#', dataIndex: 'id', width: 60 },
        { title: 'מייל', dataIndex: 'email' },
        { title: 'שם', dataIndex: 'display_name' },
        { title: 'תפקיד', dataIndex: 'role', width: 100, render: (v) => _jsx(Tag, { color: v === 'admin' ? 'red' : undefined, children: v }) },
        { title: 'שיעורים שהושלמו', dataIndex: 'completed_lessons_count', width: 160 },
        {
            title: '',
            key: 'chev',
            width: 36,
            align: 'center',
            // RTL forward chevron points left (same idiom as the dashboard
            // grades-card row chevron).
            render: () => _jsx(LeftOutlined, { style: { color: '#6D6386', fontSize: 12 } }),
        },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(PageHeader, { title: "\u05EA\u05DC\u05DE\u05D9\u05D3\u05D9\u05DD", breadcrumb: ['ניהול', 'תלמידים'] }), _jsx(Card, { children: rows.length === 0 && !loading
                    ? _jsx(Empty, { description: "\u05D0\u05D9\u05DF \u05EA\u05DC\u05DE\u05D9\u05D3\u05D9\u05DD \u05D1\u05DE\u05E2\u05E8\u05DB\u05EA \u05E2\u05D3\u05D9\u05D9\u05DF", image: Empty.PRESENTED_IMAGE_SIMPLE })
                    : (_jsx(Table, { size: "small", rowKey: "id", loading: loading, dataSource: rows, columns: cols, pagination: { pageSize: 30 }, onRow: (r) => ({
                            onClick: () => nav(`/students/${r.id}`),
                            style: { cursor: 'pointer' },
                        }) })) })] }));
}
